import apiClient from './apiClient'


const getSchedules = (tenant, projectId) => {
  return apiClient.get(`/${tenant}/Schedule/${projectId}`)
}

const getSchedule = (tenant, projectId, scheduleId) => {
  return apiClient.get(`/${tenant}/Schedule/${projectId}/${scheduleId}`)
}

const createSchedule = (tenant, projectId, schedule) => {
  return apiClient.post(`/${tenant}/Schedule/${projectId}`, schedule)
}

const putSchedule = (tenant, projectId, scheduleId, schedule) => {
  return apiClient.put(`/${tenant}/Schedule/${projectId}/${scheduleId}`, schedule)
}

const deleteSchedule = (tenant, projectId, scheduleId) => {
  return apiClient.delete(`/${tenant}/Schedule/${projectId}/${scheduleId}`)
}

const getSchedulePdf = (tenant, projectId, scheduleId) => {
  return apiClient.get(`/${tenant}/Schedule/${projectId}/${scheduleId}/pdf`, { responseType: 'blob' })
}

export default {
  getSchedules,
  getSchedule,
  createSchedule,
  putSchedule,
  deleteSchedule,
  getSchedulePdf
}
